import config from '../config';

const sdk = require('@pitchground/pitchground-sdk')({
  endpoint: typeof localStorage !== 'undefined' && localStorage.getItem('___SDK_API_ENDPOINT_OVERRIDE___') ?
    localStorage.getItem('___SDK_API_ENDPOINT_OVERRIDE___')
    : config.API_ENDPOINT,
});

export default sdk;
